(function () {
    'use strict';


    angular
        .module('aircraftRegistration')
        .factory('AircraftRegistrationRequestFactory', AircraftRegistrationRequestFactory);
    function AircraftRegistrationRequestFactory() {



    	function AcRegSearchDTO() {
            this.modelNumber=null;
            this.aircraftRegName = null;
            this.status = true;
            this.inActiveStartDate = null;
            this.inActiveEndDate = null;
            this.etop = false;
            this.sharklets = false;
            this.capacity = null;
            this.pageSize=null;
            this.startPosition=null;
        }

    	 function SaveAircraftRegistrationRequest() {
             this.aircraftRegId = null;
             this.version = null;
             this.aircraftModelCapacityId = null;
             this.aircraftRegName = null;
             this.status = null;
             this.inActiveStartDate = null;
             this.inActiveEndDate = null;
             this.airportCodeExclusions = [];
             this.etop = null;
             this.sharklets = null;
             this.version = null;
             this.modelNumber = null;
             this.capacity = null;
             this.acRegInactivePeriods = [];
             this.userConfirmUnassignFlightRotation = false;
             this.rotationUnassignPeriods = [];
             this.acmiType = null;
         }

    	 function EditAircraftRegistrationDTO() {
             this.aircraftRegId = null;
             this.version = null;
             this.aircraftModelCapacityId = null;
             this.aircraftRegName = null;
             this.status = false;
             this.inActiveStartDate = null;
             this.inActiveEndDate = null;
             this.airportCodeExclusions = [];
             this.etop = false;
             this.sharklets = false;
             this.version = null;
             this.modelNumber = null;
             this.capacity = null;
             this.aircraftInactivePeriods = [];
             this.newlyAddedInactivePeriods = [];
             this.userConfirmUnassignFlightRotation = false;
             this.rotationUnassignPeriods = [];
         }

    	 function DeleteAircraftRegistrationRequest(){
    		 this.aircraftRegId = null;
    		 this.version = null;
    	 }

    	 function InactivePeriod(){
    		 this.createdBy = null;
    		 this.createdDate = null;
    		 this.inActiveEndDate = null;
    		 this.inActiveStartDate = null;
    		 this.modifiedBy = null;
    		 this.modifiedDate = null;
    		 this.version = null;
    		 this.acRegInactivePeriodId = null;
    		 this.INAStartInvalidInEdit = false;
    		 this.INAEndInvalidInEdit = false;
    		 this.INAStartAfterEndDateInEdit = false;
 			 this.isPastInaStartDate = false;
 			 this.isPastInaEndDate = false;
 			 this.isInaStartSetToPast = false;
			 this.isInaEndSetToPast = false;
    	 }

    	 function InactivePeriodForSave(){
    		 this.inActiveEndDate = null;
    		 this.inActiveStartDate = null;
    		 this.version = null;
    		 this.aircraftRegistrationId = null;
    		 this.acRegInactivePeriodId = null;
    	 }

    	function GetAcRgistrationForEdit(registration) {
    		var newReg = new EditAircraftRegistrationDTO();
            newReg.aircraftRegId = registration.registrationID;
            newReg.version = registration.version;
            newReg.aircraftModelCapacityId = registration.modelCapacityId;
            newReg.aircraftRegName = registration.registrationName;
            newReg.status = (registration.status == "INA") ? true : false;
            newReg.inActiveStartDate = registration.inActiveStartDate;
            newReg.inActiveEndDate = registration.inActiveEndDate;
            newReg.airportCodeExclusions = registration.aircraftExclusions;
            newReg.etop = registration.etop;
            newReg.sharklets = registration.sharket;
            newReg.version = registration.version;
            newReg.modelNumber = !!registration.modelNumber ? registration.modelNumber.modelNumber : null;
            newReg.capacity = registration.capacity;
            if(!!registration.aircraftInactivePeriods){
            	newReg.aircraftInactivePeriods = registration.aircraftInactivePeriods;
            }
            newReg.acmiType = registration.acmiType;
            return newReg;

    	}

    	function GetAcRgistrationForSave(registration) {
    		var newReg = new SaveAircraftRegistrationRequest();
            newReg.aircraftRegId = registration.aircraftRegId;
            newReg.version = registration.version;
            newReg.aircraftModelCapacityId = !!registration.modelNumber ? registration.modelNumber.modelCapacityId : null;
            newReg.aircraftRegName = registration.aircraftRegName;
            newReg.status = registration.status == true ? "INA" : "ACT";
            newReg.inActiveStartDate = registration.inActiveStartDate;
            newReg.inActiveEndDate = registration.inActiveEndDate;
            newReg.etop = registration.etop;
            newReg.sharklets = registration.sharklets;
            newReg.version = registration.version;
            newReg.modelNumber =  !!registration.modelNumber ? registration.modelNumber.modelNumber : null;
            newReg.capacity = registration.capacity;
            if(!!registration.airportCodeExclusions){
            	angular.forEach(registration.airportCodeExclusions, function(apEx){
            		newReg.airportCodeExclusions.push(apEx.airPortCode);
            	});
            }
            if(!!registration.aircraftInactivePeriods){
            	angular.forEach(registration.aircraftInactivePeriods, function(acINAPeriod){
            		var period = getAndSetINAPeriod(acINAPeriod, registration.aircraftRegId);
            		if(period != null){
            			newReg.acRegInactivePeriods.push(period);
            		}
            	});
            }
            if(!!registration.newlyAddedInactivePeriods){
            	angular.forEach(registration.newlyAddedInactivePeriods, function(acINAPeriod){
            		var period = getAndSetINAPeriod(acINAPeriod, registration.aircraftRegId);
            		if(period != null){
            			newReg.acRegInactivePeriods.push(period);
            		}
            	});
            }
            newReg.userConfirmUnassignFlightRotation = registration.userConfirmUnassignFlightRotation;
            newReg.rotationUnassignPeriods = registration.rotationUnassignPeriods;
            newReg.acmiType = registration.acmiType == null ? null : registration.acmiType.acmiCode;
            return newReg;
    	}

    	function getAndSetINAPeriod(acINAPeriod, aircraftRegistrationId){
    		var newPeriod = null;
    		if(!!acINAPeriod && !!acINAPeriod.inActiveStartDate && !!acINAPeriod.inActiveEndDate){
    			newPeriod = new InactivePeriodForSave();
    			newPeriod.inActiveEndDate = acINAPeriod.inActiveEndDate;
    			newPeriod.inActiveStartDate = acINAPeriod.inActiveStartDate;
    			newPeriod.version = acINAPeriod.version;
    			newPeriod.acRegInactivePeriodId = acINAPeriod.acRegInactivePeriodId;
    			newPeriod.aircraftRegistrationId = aircraftRegistrationId;
    		}
    		return newPeriod;
    	}

    	function GetAcRgistrationDeleteReq(acReg) {
            var new_Reg = new DeleteAircraftRegistrationRequest();
            new_Reg.aircraftRegId = acReg.aircraftRegId;
            new_Reg.version = acReg.version;
            return new_Reg;
        }

    	/*function GetNewCrewBatch(){
        	var crewBatch = new CrewBatchDTO();
        	crewBatch.version = -1;
        	crewBatch.statusCode = "INA";
        	crewBatch.status = true;
        	return crewBatch;
        }*/

        function GetAcRegSearchCriteria() {
            return new AcRegSearchDTO();
        }

        function GetACRegInactivePeriod(){
        	return new InactivePeriod();
        }

        function GetNewAirCraftRegForEdit() {
        	return new EditAircraftRegistrationDTO();
		}

        function GetCapacity(){
        	var capacity = null;
        	return capacity;
        }

        return {
        	getAcRegSearchCriteria   : GetAcRegSearchCriteria,
        	getAcRgistrationForSave  : GetAcRgistrationForSave,
        	getAcRgistrationForEdit : GetAcRgistrationForEdit,
        	getAcRgistrationDeleteReq: GetAcRgistrationDeleteReq,
        	getNewAirCraftRegForEdit 	 : GetNewAirCraftRegForEdit,
        	getCapacity :GetCapacity,
        	getACRegInactivePeriod : GetACRegInactivePeriod
        }

    }
})();
